module.exports = __webpack_public_path__ + "img/serene.dacf5648.jpg";